var map = {
	"./achieve-image-01.png": "./src/assets/image/template/achieve-image-01.png",
	"./achieve-image-02.png": "./src/assets/image/template/achieve-image-02.png",
	"./achieve-image-03.png": "./src/assets/image/template/achieve-image-03.png",
	"./achieve-image-04.png": "./src/assets/image/template/achieve-image-04.png",
	"./achieve-image-05.png": "./src/assets/image/template/achieve-image-05.png",
	"./achieve-image-06.png": "./src/assets/image/template/achieve-image-06.png",
	"./achieve-image-1.png": "./src/assets/image/template/achieve-image-1.png",
	"./achieve-image-2.png": "./src/assets/image/template/achieve-image-2.png",
	"./achieve-image-3.png": "./src/assets/image/template/achieve-image-3.png",
	"./achieve-image-4.png": "./src/assets/image/template/achieve-image-4.png",
	"./achieve-image-5.png": "./src/assets/image/template/achieve-image-5.png",
	"./achieve-image-6.png": "./src/assets/image/template/achieve-image-6.png",
	"./achieve-image-7.png": "./src/assets/image/template/achieve-image-7.png",
	"./achieve1-image-2.png": "./src/assets/image/template/achieve1-image-2.png",
	"./activityLevel-image-1.png": "./src/assets/image/template/activityLevel-image-1.png",
	"./activityLevel-image-2.png": "./src/assets/image/template/activityLevel-image-2.png",
	"./activityLevel-image-3.png": "./src/assets/image/template/activityLevel-image-3.png",
	"./activityLevel-image-4.png": "./src/assets/image/template/activityLevel-image-4.png",
	"./activityLevel-image-5.png": "./src/assets/image/template/activityLevel-image-5.png",
	"./age-image-1.png": "./src/assets/image/template/age-image-1.png",
	"./age-image-2.png": "./src/assets/image/template/age-image-2.png",
	"./age-image-3.png": "./src/assets/image/template/age-image-3.png",
	"./age-image-4.png": "./src/assets/image/template/age-image-4.png",
	"./bodypart-image.png": "./src/assets/image/template/bodypart-image.png",
	"./bodytype-image-1.png": "./src/assets/image/template/bodytype-image-1.png",
	"./bodytype-image-2.png": "./src/assets/image/template/bodytype-image-2.png",
	"./bodytype-image-3.png": "./src/assets/image/template/bodytype-image-3.png",
	"./breathCondition-image-1.png": "./src/assets/image/template/breathCondition-image-1.png",
	"./breathCondition-image-2.png": "./src/assets/image/template/breathCondition-image-2.png",
	"./breathCondition-image-3.png": "./src/assets/image/template/breathCondition-image-3.png",
	"./breathCondition-image-4.png": "./src/assets/image/template/breathCondition-image-4.png",
	"./dietScreen-image-1.png": "./src/assets/image/template/dietScreen-image-1.png",
	"./dietScreen-image-2.png": "./src/assets/image/template/dietScreen-image-2.png",
	"./dietScreen-image-3.png": "./src/assets/image/template/dietScreen-image-3.png",
	"./dietScreen-image-4.png": "./src/assets/image/template/dietScreen-image-4.png",
	"./dietScreen-image-5.png": "./src/assets/image/template/dietScreen-image-5.png",
	"./dream-bodytype-image-1.png": "./src/assets/image/template/dream-bodytype-image-1.png",
	"./dream-bodytype-image-2.png": "./src/assets/image/template/dream-bodytype-image-2.png",
	"./dream-bodytype-image-3.png": "./src/assets/image/template/dream-bodytype-image-3.png",
	"./energyLevel-image-1.png": "./src/assets/image/template/energyLevel-image-1.png",
	"./energyLevel-image-2.png": "./src/assets/image/template/energyLevel-image-2.png",
	"./energyLevel-image-3.png": "./src/assets/image/template/energyLevel-image-3.png",
	"./energyLevel-image-4.png": "./src/assets/image/template/energyLevel-image-4.png",
	"./eventScreen-image-1.png": "./src/assets/image/template/eventScreen-image-1.png",
	"./eventScreen-image-2.png": "./src/assets/image/template/eventScreen-image-2.png",
	"./eventScreen-image-3.png": "./src/assets/image/template/eventScreen-image-3.png",
	"./eventScreen-image-4.png": "./src/assets/image/template/eventScreen-image-4.png",
	"./eventScreen-image-5.png": "./src/assets/image/template/eventScreen-image-5.png",
	"./eventScreen-image-6.png": "./src/assets/image/template/eventScreen-image-6.png",
	"./eventScreen-image-7.png": "./src/assets/image/template/eventScreen-image-7.png",
	"./eventScreen-image-8.png": "./src/assets/image/template/eventScreen-image-8.png",
	"./familiarity-image-1.png": "./src/assets/image/template/familiarity-image-1.png",
	"./familiarity-image-2.png": "./src/assets/image/template/familiarity-image-2.png",
	"./familiarity-image-3.png": "./src/assets/image/template/familiarity-image-3.png",
	"./flexibilty-image-1.png": "./src/assets/image/template/flexibilty-image-1.png",
	"./flexibilty-image-2.png": "./src/assets/image/template/flexibilty-image-2.png",
	"./flexibilty-image-3.png": "./src/assets/image/template/flexibilty-image-3.png",
	"./generationScreen-image.png": "./src/assets/image/template/generationScreen-image.png",
	"./happybody-image-1.png": "./src/assets/image/template/happybody-image-1.png",
	"./happybody-image-2.png": "./src/assets/image/template/happybody-image-2.png",
	"./happybody-image-3.png": "./src/assets/image/template/happybody-image-3.png",
	"./happybody-image-4.png": "./src/assets/image/template/happybody-image-4.png",
	"./happybody-image-5.png": "./src/assets/image/template/happybody-image-5.png",
	"./intro-image-1-cy.png": "./src/assets/image/template/intro-image-1-cy.png",
	"./intro-image-1.png": "./src/assets/image/template/intro-image-1.png",
	"./intro-image-2.png": "./src/assets/image/template/intro-image-2.png",
	"./intro-image-3.png": "./src/assets/image/template/intro-image-3.png",
	"./intro-image-4.png": "./src/assets/image/template/intro-image-4.png",
	"./intro-image-5.png": "./src/assets/image/template/intro-image-5.png",
	"./intro-image-6.png": "./src/assets/image/template/intro-image-6.png",
	"./preferredPosition-image-1.png": "./src/assets/image/template/preferredPosition-image-1.png",
	"./preferredPosition-image-2.png": "./src/assets/image/template/preferredPosition-image-2.png",
	"./preferredPosition-image-3.png": "./src/assets/image/template/preferredPosition-image-3.png",
	"./purpost-image-1.png": "./src/assets/image/template/purpost-image-1.png",
	"./purpost-image-2.png": "./src/assets/image/template/purpost-image-2.png",
	"./restriction-image-1.png": "./src/assets/image/template/restriction-image-1.png",
	"./restriction-image-2.png": "./src/assets/image/template/restriction-image-2.png",
	"./restriction-image-3.png": "./src/assets/image/template/restriction-image-3.png",
	"./restriction-image-3.png.png": "./src/assets/image/template/restriction-image-3.png.png",
	"./restriction-image-4.png": "./src/assets/image/template/restriction-image-4.png",
	"./restriction-image-5.png": "./src/assets/image/template/restriction-image-5.png",
	"./restriction-image-6.png": "./src/assets/image/template/restriction-image-6.png",
	"./restriction-image-7.png": "./src/assets/image/template/restriction-image-7.png",
	"./sleepHourScreen-image.png": "./src/assets/image/template/sleepHourScreen-image.png",
	"./summary-image-1.png": "./src/assets/image/template/summary-image-1.png",
	"./summary-image-2.png": "./src/assets/image/template/summary-image-2.png",
	"./summary-image-3.png": "./src/assets/image/template/summary-image-3.png",
	"./summary-image-4.png": "./src/assets/image/template/summary-image-4.png",
	"./transition-mainimage.png": "./src/assets/image/template/transition-mainimage.png",
	"./walkingDuration-image-1.png": "./src/assets/image/template/walkingDuration-image-1.png",
	"./walkingDuration-image-2.png": "./src/assets/image/template/walkingDuration-image-2.png",
	"./walkingDuration-image-3.png": "./src/assets/image/template/walkingDuration-image-3.png",
	"./waterDrinkScreen-image-1.png": "./src/assets/image/template/waterDrinkScreen-image-1.png",
	"./waterDrinkScreen-image-2.png": "./src/assets/image/template/waterDrinkScreen-image-2.png",
	"./waterDrinkScreen-image-3.png": "./src/assets/image/template/waterDrinkScreen-image-3.png",
	"./waterDrinkScreen-image-4.png": "./src/assets/image/template/waterDrinkScreen-image-4.png",
	"./yogaLevel-image-1.png": "./src/assets/image/template/yogaLevel-image-1.png",
	"./yogaLevel-image-2.png": "./src/assets/image/template/yogaLevel-image-2.png",
	"./yogaLevel-image-3.png": "./src/assets/image/template/yogaLevel-image-3.png",
	"./yogaLevel-image-4.png": "./src/assets/image/template/yogaLevel-image-4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image/template sync recursive ^\\.\\/.*\\-.*\\.png$";